import React from 'react';
import { Entity, stringifyEntityRef } from '@backstage/catalog-model';
import { useAzureContext } from './AzureContext';
import { AzureVmTable, VmssTable } from './tables';
import { Box, Typography } from '@mui/material';
import { CRDAzureConfig } from '@internal/backstage-plugin-compute-resource-discovery-new-common';

// Helper function to group Azure configs by resource group
const groupAzureConfigs = (configs: CRDAzureConfig[]) => {
  const grouped: { [key: string]: CRDAzureConfig[] } = {};

  configs.forEach(config => {
    const key = config.resourceGroup || 'unknown';
    if (!grouped[key]) {
      grouped[key] = [];
    }
    grouped[key].push(config);
  });

  return grouped;
};

export const Azure: React.FC<{ entity: Entity }> = ({ entity }) => {
  const { azureConfigs } = useAzureContext();
  const groupedConfigs = groupAzureConfigs(azureConfigs);

  return (
    <>
      {Object.entries(groupedConfigs).map(([resourceGroup, configs]) => (
        <Box key={resourceGroup} sx={{ mb: 4 }}>
          {/* Resource Group Header */}
          <Box
            sx={{
              mb: 2,
              p: 2,
              backgroundColor: '#E3F2FD',
              borderRadius: 1,
              border: '1px solid #0078D4',
            }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Typography
                variant="h6"
                sx={{ color: '#0078D4', fontWeight: 'bold' }}
              >
                Resource Group: {resourceGroup}
              </Typography>
            </Box>
          </Box>

          {/* Resource Tables for this resource group */}
          {configs.map((config, configIdx) => (
            <Box key={configIdx} sx={{ mb: 2 }}>
              {config.resourceTypes?.includes('vm') && (
                <Box sx={{ mb: 2 }}>
                  <AzureVmTable
                    title="Virtual Machines"
                    entityRef={stringifyEntityRef(entity)}
                    azureConfig={config}
                  />
                </Box>
              )}
              {config.resourceTypes?.includes('vmss') && (
                <Box sx={{ mb: 2 }}>
                  <VmssTable
                    title="Virtual Machine Scale Sets"
                    entityRef={stringifyEntityRef(entity)}
                    azureConfig={config}
                  />
                </Box>
              )}
            </Box>
          ))}
        </Box>
      ))}
    </>
  );
};
